import { flow, types } from 'mobx-state-tree'
import { actions } from '@sr/routes/common'
import { BaseRouteState, Policy, SocialReferent } from '@shared/data-access'

export const DeclareClaimRouteState = BaseRouteState.named(
  'DeclareClaimRouteState',
)
  .props({
    policyId: types.maybeNull(types.string),
    policy: types.maybeNull(types.reference(Policy)),
    user: types.maybeNull(types.reference(SocialReferent)),
  })
  .actions((self) => ({
    ...actions(self),
    afterAttach() {
      self.loadPolicy()
      self.loadUserInfo()
    },
    declareClaim: flow(function* declareClaim() {
      if (!self.user?.isCoordinator) return
      self.setLoading('DeclareClaimRouteState')
      try {
        yield self.savePolicyOnlyData({ registry_type: 'S' })
      } catch (error) {
        console.error('Error declaring claim:', error)
        throw new Error(error)
      } finally {
        self.removeLoading('DeclareClaimRouteState')
      }
    }),
  }))
